module.exports = __webpack_public_path__ + "static/media/Practitioner.fcf4e3bb.png";